import { useContext, useState } from 'react'

import { SL_Button } from '../../../components/buttons/Button'

import { displayMessage } from '../../../helpers/messages'
import { GeneralContext } from '../../../context/GeneralContext/GeneralContext'
import { Input } from 'antd'
import api from '../../../services/api'

export default function Approval({ isApproval, token, onRecharge }) {
    const { mobile_mode, showAlert, enums } = useContext(GeneralContext)

    const [reason, setReason] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const sendApproval = async () => {
        setIsLoading(true)
        try {
            const body = {
                status: isApproval ? enums.EApprovalStatus.APPROVED.code : enums.EApprovalStatus.REJECTED.code,
                approval_narrative: reason
            }
            const { data } = await api.approvals.update(token, body)
            console.log(data)
            onRecharge()
        } catch (error) {
            showAlert(error?.response?.data?.error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <div className="flex flex-col justify-start gap-2 w-full">
            <div className="flex flex-col gap-5">
                <span className="text-center uppercase font-bold text-2xl text-white">{displayMessage(isApproval ? 'RAE_APPROVAL' : 'RAE_REJECTION')}</span>
                <Input.TextArea
                    textarea={true}
                    readOnly={isLoading}
                    rows={mobile_mode ? 13 : 10}
                    value={reason}
                    onChange={(e) => {
                        setReason(e.target.value)
                    }}
                    type="primary"
                    className="w-full shadow-md"
                />
                <SL_Button className={`h-[50px] font-bold text-xl ${isApproval ? 'bg-green-600' : 'bg-sl-red-500'} `} onClick={() => sendApproval()} loading={isLoading}>
                    {displayMessage(isApproval ? 'APPROVE' : 'REJECT')}
                </SL_Button>
            </div>
        </div>
    )
}
